import { render, staticRenderFns } from "./FieldSetFieldAdminAdd.vue?vue&type=template&id=2457a9ef&scoped=true"
import script from "./FieldSetFieldAdminAdd.vue?vue&type=script&lang=js"
export * from "./FieldSetFieldAdminAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457a9ef",
  null
  
)

export default component.exports